var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'px-1',

    // Text
    _vm.sizePreset === _vm.OzBadgeSizePreset.Default && 'text-12-16 font-semibold',

    // Shape
    'rounded',

    // Colors
    _vm.colorScheme === _vm.OzBadgeColorScheme.Default && [
      // Text
      {
        'text-grey-700': _vm.darkMode === false,
        'text-grey-200': _vm.darkMode === true,
        'text-grey-700 dark:text-grey-200': _vm.darkMode === 'auto',
      },
      // Border
      {
        'border border-dashed': true,

        'border-grey-700': _vm.darkMode === false,
        'border-grey-200': _vm.darkMode === true,
        'border-grey-700 dark:border-grey-200': _vm.darkMode === 'auto',
      },
    ],
    _vm.colorScheme === _vm.OzBadgeColorScheme.Selection && [
      // Text
      {
        'text-grape-500': _vm.darkMode === false,
        'text-canary-500': _vm.darkMode === true,
        'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
      },
      // Border
      {
        'border border-dashed': true,

        'border-grape-500': _vm.darkMode === false,
        'border-canary-500': _vm.darkMode === true,
        'border-grape-500 dark:border-canary-500': _vm.darkMode === 'auto',
      },
    ],
    _vm.colorScheme === _vm.OzBadgeColorScheme.Disabled && [
      // Text
      {
        'text-dark-text-300': _vm.darkMode === false,
        'text-light-text-300': _vm.darkMode === true,
        'text-dark-text-300 dark:text-light-text-300': _vm.darkMode === 'auto',
      },
      // Border
      {
        'border border-dashed': true,

        'border-dark-text-300': _vm.darkMode === false,
        'border-light-text-300': _vm.darkMode === true,
        'border-dark-text-300 dark:border-light-text-300': _vm.darkMode === 'auto',
      },
    ],
  ]},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }